import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  'e73f2672daf411498a3da45014fd6ac5Tz0xMTc4NTYsRT0xNzg3MTgzOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
)

export default LicenseInfo
